var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#B558F6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0296 11.4538C23.4245 10.8487 22.4464 10.8487 21.8414 11.4538L21.0098 12.2826L23.7146 14.9875L24.5462 14.1559C25.1513 13.5508 25.1513 12.5727 24.5462 11.9677L24.0296 11.4538ZM15.7631 17.532C15.5946 17.7006 15.4647 17.9078 15.3902 18.1371L14.5724 20.5905C14.4922 20.8281 14.5558 21.0906 14.7326 21.2702C14.9094 21.4498 15.1719 21.5105 15.4123 21.4304L17.8657 20.6126C18.0922 20.538 18.2994 20.4082 18.4707 20.2396L23.093 15.6146L20.3854 12.9071L15.7631 17.532ZM13.6523 12.6225C12.188 12.6225 11 13.8105 11 15.2748V22.3477C11 23.812 12.188 25 13.6523 25H20.7252C22.1895 25 23.3775 23.812 23.3775 22.3477V19.6953C23.3775 19.2063 22.9824 18.8112 22.4934 18.8112C22.0044 18.8112 21.6093 19.2063 21.6093 19.6953V22.3477C21.6093 22.8367 21.2142 23.2318 20.7252 23.2318H13.6523C13.1633 23.2318 12.7682 22.8367 12.7682 22.3477V15.2748C12.7682 14.7858 13.1633 14.3907 13.6523 14.3907H16.3047C16.7937 14.3907 17.1888 13.9956 17.1888 13.5066C17.1888 13.0176 16.7937 12.6225 16.3047 12.6225H13.6523Z",
    fill: "#B558F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerIcon);
export default __webpack_public_path__ + "static/media/answer-icon.cdd7d1fc9e6151c2b21efe4c5f719281.svg";
export { ForwardRef as ReactComponent };